export const INPUT_TEXT_FIELD = "INPUT_TEXT_FIELD";
export const INPUT_TEXTAREA_FIELD = "INPUT_TEXTAREA_FIELD";
